import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  register(retailer) {
    return RetailerApiClient.post('auth/signup', retailer)
      .then(response => {
        return response
      })
      .catch(error => {
        throw error
      })
  },
  saveActivities(data) {
    return RetailerApiClient.post('auth/signup/activities', data)
      .then(response => {
        return response
      })
      .catch(error => {
        throw error
      })
  },
  login(user) {
    return RetailerApiClient.post('auth/login', user)
      .then(response => {
        return response
      })
      .catch(error => {
        throw error
      })
  },
  logout() {
    return RetailerApiClient.get('auth/logout')
      .then(response => {
        return response
      })
      .catch(error => {
        throw error
      })
  },
  forgotPassword(email) {
    return RetailerApiClient.post('auth/password/email', email)
      .then(response => {
        return response
      })
      .catch(error => {
        throw error
      })
  },
  resetPassword(retailer) {
    return RetailerApiClient.post('auth/password/reset', retailer)
      .then(response => {
        return response
      })
      .catch(error => {
        throw error
      })
  },
  getUser() {
    return RetailerApiClient.get('auth/user')
      .then(response => {
        return response
      })
      .catch(error => {
        throw error
      })
  },
  acceptPolicy() {
    return RetailerApiClient.post('auth/accept-policy')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
